import React from 'react';

import classNames from 'classnames';
import { IconButton, SvgIcon, Switch } from '@infoods/lifebase-ui';

import classes from './SchoolInfoRow.module.scss';
import { ReactComponent as PenIcon } from '../../../../shared/assets/icons/penBig.svg';
import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { SeparatorLine } from '../../../../shared/components/ui-components';
import { SchoolInfo } from '../../../../shared/interfaces/school/SchoolInfo';

type SchoolInfoRowProps = {
  onEdit: (schoolInfo: SchoolInfo) => void;
  onActivationStatusChange: (value: number, status: boolean) => void;
  schoolInfo: SchoolInfo;
};

const SchoolInfoRow = ({
  onEdit,
  onActivationStatusChange,
  schoolInfo,
}: SchoolInfoRowProps) => {
  const { name, amountOfCustomers, active, id } = schoolInfo;

  const handelEditSchool = () => {
    onEdit(schoolInfo);
  };

  const handelSchoolActivationChange = () => {
    onActivationStatusChange(id, !active);
  };

  const rowClasses = classNames({ [classes.deactivated]: !active });

  return (
    <GridTableRow variant="row" className={rowClasses}>
      <GridTableCell variant="title" className="private-info">
        {name}
      </GridTableCell>
      <GridTableCell className="private-info">{amountOfCustomers}</GridTableCell>
      <GridTableCell justify="end" className={classes.optionBlock}>
        <Switch checked={active} onChange={handelSchoolActivationChange} />
        <SeparatorLine />
        <IconButton color="secondary" onClick={handelEditSchool} disabled={!active}>
          <SvgIcon component={PenIcon} inheritViewBox fontSize="large" />
        </IconButton>
      </GridTableCell>
    </GridTableRow>
  );
};

export { SchoolInfoRow };
